import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    FRANCHISE_APPLY_PAGE_LOADING() {
      return {
        isLoading: true,
        franchiseApplyPage: action.franchiseApplyPage
      };
    },
    FRANCHISE_APPLY_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'brands-that-matter',
        'categoryPage'
      );

      return {
        isLoading: false,
        data: action.franchiseApplyPage,
        ads: adModelData
      };
    },
    FRANCHISE_APPLY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.franchiseApplyPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
